
export const usernameHandleParse = (value) => (value || '').replace(/^(.*?)\/([^/]+$)(\/|)/i, '$2').replace(/[^a-zA-Z0-9-_~.]+/gi, '');
export const numberHandleParse = (value) => (value || '').replace(/[^+0-9]+/gi, '');



// WEBPACK FOOTER //
// ./src/components/SmartLinks/schemes/parsers.js